import React, { useState, useEffect } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { deleteRateList, getManagerRatePriceList } from "../../../api/api";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import AddManagerRatePopup from "../../common/AddManagerRatePopup";
import DeletePopup from "../../common/DeletePopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { type } from "../../common/AdminAuth";
const ManagerRateAndRouteList = () => {
  let { systemID } = useParams();

  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [routeAndrateList, setRouteAndrateList] = useState([]);
  const [updateID, setupdateID] = useState({
    id: "",
    systemID: "",
    editData: null,
  });

  const getUserDetails = () => {
    getManagerRatePriceList(systemID).then((res) => {
      if (res.data.success === true) {
        setRouteAndrateList(res.data.data);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  const yesDelete = () => {
    deleteRateList(updateID.id, updateID.systemID).then((res) => {
      if (res.data.success === true) {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-success",
        });
        setTimeout(() => {
          window.location.href = `/admin/manager/rate-route-list/${systemID}`;
        }, 1000);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              <div className="row">
                <div className="col-lg-12 col-md-12 order-1">
                  {error.errarStatus ? (
                    <div className={error.bgcolor} role="alert">
                      <strong>Alert!</strong> {error.errorMessage}
                      <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  ) : null}

                  <div className="">
                    <div className="card">
                      {type === "Manager" ? 
                       <h5 className="card-header ">
                          Route List
                        </h5> : (
                        <h5 className="card-header ">
                          Route and rate list of{" "}
                          <span className="text-success">{systemID}</span>

                          {type === "Admin" && 
                          <span className="demo-inline-spacing float-right ">
                            <Link
                              className="btn btn-primary me-1"
                              to="/admin/manager"
                            >
                              <FontAwesomeIcon icon={faArrowLeft} /> Back to
                              manager
                            </Link>
                          </span>}
                        </h5>
                      )}

                      <div className="table-responsive text-nowrap">
                        <table className="table">
                          <thead>
                            <tr>
                              <th> Country </th>
                              <th> Route </th>
                              {type === "Admin" && <th> Buy Price </th>}
                              {type === "Admin" && <th> Margin (%) </th>}
                              {type === "Admin" && <th> Selling Price </th>}
                              {(type === "Manager" || type === "Emp") && <th>Price</th>}
                              <th> Status </th>
                              {type === "Admin" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody className="table-border-bottom-0">
                            {routeAndrateList.map((items, i) => (
                              <tr key={i}>
                                <td>
                                  <span className="text-primary">
                                    {items.country_name}
                                  </span>{" "}
                                  ({items.country_code})
                                </td>
                                <td>{items.route_name}</td>
                                {type === "Admin" && <td>{items.buy_price}</td>}
                                {type === "Admin" && <td>{items.margin}</td>}
                                {type === "Admin" && <td>{items.selling_price}</td>}
                                {type === "Manager" || type === "Emp" && <td>{items.selling_price}</td>}
                                <td>
                                  {items.status === 1 ? (
                                    <span className="badge bg-label-primary me-1">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-label-danger me-1">
                                      Inactive
                                    </span>
                                  )}
                                </td>

                               {type === "Admin" &&
                                <td>
                                  <span
                                    role="button"
                                    data-toggle="modal"
                                    data-target="#managerRateModal"
                                    className="badge bg-label-primary me-1"
                                    onClick={(e) =>
                                      setupdateID({
                                        id: items.id,
                                        systemID: systemID,
                                        editData: items,
                                      })
                                    }
                                  >
                                    Update Price
                                  </span>
                                  <span
                                    role="button"
                                    data-toggle="modal"
                                    data-target="#delete"
                                    className="badge bg-label-danger me-1"
                                    onClick={(e) =>
                                      setupdateID({
                                        id: items.id,
                                        systemID: systemID,
                                      })
                                    }
                                  >
                                    Delete
                                  </span>
                                </td>}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddManagerRatePopup
        type={"edit"}
        id={updateID.id}
        selectedSystemID={updateID.systemID}
        editData={updateID.editData}
      />
      <DeletePopup yesDelete={yesDelete} />
    </div>
  );
};

export default ManagerRateAndRouteList;
